import {ActionButtonStyle} from './styles';

const ActionButton = (props: any) => <ActionButtonStyle {...props} href={props.href + `?utm_source=webVNW&utm_medium=Traffic&utm_campaign=Entry2023`}>{
	props.children
}</ActionButtonStyle>
export default ActionButton
